import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import ModalContainer from '@modals/ModalContainer';
import { Modal } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType, useFlow } from '@stackflow/react';
import { useTranslation } from 'react-i18next';

declare module '@stackflow/config' {
    interface Register {
        NickNameChangeModal: {};
    }
}

const NickNameChangeModal: ActivityComponentType<'NickNameChangeModal'> = () => {
    const { t } = useTranslation('accountSetting');
    const { pop } = useFlow();
    return (
        <Modal>
            <ModalContainer>
                <Column fullWidth align='center'
                    spacing={24} >
                    <Text size='xl'>{t('nicknameModal.success')}</Text>
                    <Button onClick={pop}
                        fullWidth >
                        {t('nicknameModal.confirm')}
                    </Button>
                </Column>
            </ModalContainer>
        </Modal>
    );
};

export default NickNameChangeModal;
